class Paging {
  constructor(pageNo = 1, pageSize = 10, totalCount = 1, hasMore = false ){

    this.pageNo = pageNo,
    this.pageSize = pageSize,
    this.totalCount = totalCount,
    this.hasMore = hasMore
  }
}

export {Paging};